import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-offer-delete',
  templateUrl: './offer-delete.component.html',
  styleUrls: ['./offer-delete.component.css']
})
export class OfferDeleteComponent implements OnInit {

  OfferData: any = []
  cid:any
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  offerId = ""

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllOffer()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllOffer();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllOffer();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllOffer(){
    this.generic_service.getAllOffer().subscribe(
      (res:any)=> {
        console.log(res)
        this.OfferData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  del(id:any){
    this.offerId = id
  }

  deleteOffer(){
    this.generic_service.deleteOffer(this.offerId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllOffer()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}
